import { Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { matchTarget, type NavTarget } from './navigation';

interface Crumb {
  label: string;
  to?: string;
}

/**
 * Trilha montada da navegação e do título declarado na rota: grupo › módulo › página. No
 * celular fica só o último nível — o resto está a um toque, na gaveta.
 */
export function ShellBreadcrumb({ targets, title }: { targets: NavTarget[]; title?: string }) {
  const { pathname } = useLocation();
  const target = matchTarget(targets, pathname);

  const crumbs: Crumb[] = [];
  if (target?.parent) crumbs.push({ label: target.parent });
  if (target) crumbs.push({ label: target.label, to: target.to });
  if (title && title !== target?.label) crumbs.push({ label: title });
  if (crumbs.length === 0) return null;

  return (
    <Breadcrumb className="min-w-0">
      <BreadcrumbList className="flex-nowrap">
        {crumbs.map((crumb, index) => {
          const last = index === crumbs.length - 1;
          return (
            <Fragment key={`${crumb.label}-${index}`}>
              <BreadcrumbItem className={last ? 'min-w-0' : 'hidden md:inline-flex'}>
                {last ? (
                  <BreadcrumbPage className="truncate">{crumb.label}</BreadcrumbPage>
                ) : crumb.to ? (
                  <BreadcrumbLink asChild>
                    <Link to={crumb.to}>{crumb.label}</Link>
                  </BreadcrumbLink>
                ) : (
                  crumb.label
                )}
              </BreadcrumbItem>
              {!last && <BreadcrumbSeparator className="hidden md:block" />}
            </Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
